import { useState } from 'react';

export const TEST_PLAYBOOK_TABS = {
  INPUT_EVENT: '0',
  PIPELINE_OUTPUT: '1',
  PLAYBOOK_OUTPUT: '2',
  SERVER_RESPONSE: '3',
};

export default function useTestPlaybookTabs() {
  const [selectedTab, setSelectedTab] = useState(TEST_PLAYBOOK_TABS.INPUT_EVENT);

  const onSelectTab = newTab => {
    setSelectedTab(newTab);
  };

  return [selectedTab, { onSelectTab }];
}
